<template>
  <div v-if="pageName">
    <div v-if="pageName === 'TNC'">
      <router-view></router-view>
    </div>
    <div class="agc-guest" v-else-if="auth">
      <AppToolBar></AppToolBar>
      <div class="agc-guest__bg"></div>
      <div class="agc-guest__body">
        <router-view></router-view>
      </div>
    </div>
    <div v-else class="agc-app">
      <AppToolBar></AppToolBar>
      <div class="agc-app__body">
        <AppDrawer></AppDrawer>
        <div class="agc-app__main">
          <router-view></router-view>
        </div>
      </div>
      <LoadingSpinner v-if="isLoading"></LoadingSpinner>
    </div>
  </div>
</template>

<script>
import LoadingSpinner from '@/components/LoadingSpinner.vue';
import { mapState } from 'vuex';
import AppToolBar from './components/AppToolBar.vue';
import AppDrawer from './components/AppDrawer.vue';

export default {
  components: {
    AppToolBar,
    AppDrawer,
    LoadingSpinner,
  },
  computed: {
    pageName() {
      return this.$route.name;
    },
    auth() {
      return this.$route.meta.auth;
    },
    ...mapState(['isLoading']),
  },
};
</script>

<style lang="scss">
@import "assets/scss/app";
</style>

<style scoped lang="scss">
@import "assets/scss/variables";

.agc-app {
  position: relative;
  background: #f0f3f8;

  &__body {
    display: flex;
  }

  &__main {
    flex-grow: 1;
    padding-top: $toolbar-height;
    margin-bottom: 2rem;
    min-width: 0;
    min-height: calc(100vh - #{$toolbar-height} + 2rem);

    @include respond(tab-landscape) {
      padding-top: 0px;
    }
  }
}

.agc-guest {
  position: relative;

  &__bg {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-image: url(assets/img/bg.jpg);
    z-index: -1;
    background-size: 100% 100%;
    background-position: top;
  }

  &__body {
    margin-top: 100px;
    margin-bottom: 100px;
  }
}
</style>
